import { NOT_APPLICABLE } from '@/data/constants/gtm';
import { TYPES } from '@/data/constants/product';
import { PdpDeliveryOptions } from '@/data/Content/PdpDeliveryOptions';
import { ProductType } from '@/data/types/Product';
import { GA4DeliveryDaysEventParams } from 'presentation/events/types/ga4Types';
import { buildDeliveryDaysEventParams } from 'presentation/events/utils/ga4Utils';

const LEAD_TIME_KEY_PREFIX = 'x_itemleadtime.';

export const isLeadTimeStaleForStore = (product: ProductType, physicalStoreId: string): boolean => {
	const sources: ProductType[] = product.type === TYPES.kit ? product.components ?? [] : [product];
	const keys = sources.flatMap((source) =>
		Object.keys(source ?? {}).filter((key) => key.startsWith(LEAD_TIME_KEY_PREFIX))
	);
	return keys.length > 0 && !keys.includes(`${LEAD_TIME_KEY_PREFIX}${physicalStoreId}`);
};

export const getDeliveryDays = (
	isStoreOnlyAvailable: boolean,
	{ delivery, pickup }: Pick<PdpDeliveryOptions, 'delivery' | 'pickup'>
): GA4DeliveryDaysEventParams =>
	isStoreOnlyAvailable
		? { estimated_delivery_days: NOT_APPLICABLE, pick_up_days: NOT_APPLICABLE }
		: {
				...buildDeliveryDaysEventParams({
					homeDeliveryDate:
						delivery.status === 'with-date' || delivery.status === 'same-day'
							? delivery.deliveryDate
							: undefined,
					pickupDate: pickup.status === 'with-date' ? pickup.deliveryDate : undefined,
				}),
				...(delivery.status === 'same-day' && { express_delivery: 'true' as const }),
		  };
